<template>
  <div class="form-tpl">
    <el-form
      ref="ruleForm"
      :model="form"
      label-width="80px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="标题">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <editoritem
          :value.sync="form.content"
          @change="changValue"
        ></editoritem>
      </el-form-item>
      <el-form-item label="内容分类" prop="contentType">
        <el-select v-model="form.contentType">
          <el-option
            v-for="item in contentTypeSelect"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="程序分类" prop="programType">
        <el-select v-model="form.programType">
          <el-option
            v-for="item in programTypeSelect"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="别语">
        <el-input v-model="form.slogan"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="图片地址/新闻网址">
        <el-input v-model="form.url"></el-input>
        <el-image
          v-if="form.url"
          :src="form.url"
          fit="contain"
          :alt="form.slogan"
          style="width: 100px; height: 100px; z-index: 100000"
          :preview-src-list="preview"
        ></el-image>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-input v-model="form.createTime" disabled></el-input>
      </el-form-item>
    </el-form>
    <el-button v-loading="saveLoing" type="primary" @click="save('ruleForm')"
      >保存</el-button
    >
    <el-button v-loading="saveLoing" type="danger" @click="deleteContent"
      >删除</el-button
    >
  </div>
</template>

<script>
import {
  program_type_select,
  content_type_select
} from '../../common/enum/imgEnum'
import Editoritem from './Editoritem'
import HomeApi from '../../network/home'

export default {
  name: 'FormTpl',
  components: {
    Editoritem
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    fatherFrom: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      programTypeSelect: program_type_select,
      contentTypeSelect: content_type_select,
      saveLoing: false,
      banner: [],
      preview: [],
      rules: {
        contentType: [
          { required: true, message: '请输入内容分类', trigger: 'blur' }
        ],
        programType: [
          { required: true, message: '请输入程序分类', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        this.preview = []
        this.preview.push(val.url)
      },
      deep: true
    }
  },
  created() {
    this.preview.push(this.form.url)
  },
  methods: {
    // 保存内容
    async save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.form.isInsert) {
            await this._updageContent(this.form)
          } else {
            await this._insertContent(this.form)
            if (
              Object.keys(this.fatherFrom).length > 0 &&
              this.fatherFrom.isUpdate
            ) {
              await this._updageContent(this.fatherFrom)
              this.fatherFrom.isUpdate = false
            }
          }
        }
      })
    },
    changValue(value) {
      this.form.content = value
    },

    // 修改
    async _updageContent(form) {
      try {
        const result = await HomeApi.updateContent(form)
        if (result.code === '00000') {
          this.$message.success({ content: result.msg })
        } else {
          this.$message.error({ content: result.msg })
        }
      } catch (e) {
        this.$message.error({ content: e })
      } finally {
        this.saveLoing = false
        this.$emit('refresh', this.form.contentType)
      }
    },

    // 增加
    async _insertContent(form) {
      try {
        const result = await HomeApi.insertContent(form)
        if (result.code === '00000') {
          this.$message.success({ content: result.msg })
        } else {
          this.$message.error({ content: result.msg })
        }
      } catch (e) {
        this.$message.error({ content: e })
      } finally {
        this.saveLoing = false
        this.form = {}
        this.$emit('refreshInsert', this.form.contentType)
      }
    },

    // 删除
    async deleteContent() {
      try {
        const result = await HomeApi.deleteById(this.form.id)
        if (result.code === '00000') {
          this.$message.success({ content: result.msg })
        } else {
          this.$message.error({ content: result.msg })
        }
      } catch (e) {
        this.$message.error({ content: e })
      } finally {
        this.saveLoing = false
        this.$emit('refresh', this.form.contentType)
      }
    }
  }
}
</script>

<style scoped></style>
